import React from "react";

interface AccordionShimmerProps {
  className?: string;
  itemCount?: number;
}

const AccordionShimmer: React.FC<AccordionShimmerProps> = ({
  className = "",
  itemCount = 6,
}) => {
  return (
    <div className={`w-full flex flex-col gap-2 ${className}`}>
      {[...Array(itemCount)].map((_, index) => (
        <div key={`accordion-shimmer-${index}`} className="w-full">
          <div
            className={`w-full p-[12px] bg-pure-white dark:bg-pure-white-dk flex items-center justify-between   ${
              index < itemCount - 1 && index >= 2
                ? "border-b border-border-gray dark:border-border-gray-dk"
                : ""
            }`}
          >
            <div className="h-4 w-32 bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded animate-pulse "></div>
            <div className="w-4 h-4 bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded animate-pulse"></div>
          </div>

          {index < 2 && (
            <div className="w-full p-[12px]  bg-pure-white dark:bg-pure-white-dk space-y-3 border-b border-border-gray dark:border-border-gray-dk">
              <div className="space-y-2">
                <div className="h-4 w-full bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded animate-pulse"></div>
                <div className="h-4 w-3/4 bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded animate-pulse"></div>
                <div className="h-4 w-5/6 bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded animate-pulse"></div>
              </div>
              <div className="space-y-2">
                <div className="h-4 w-2/3 bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded animate-pulse"></div>
                <div className="h-4 w-1/2 bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded animate-pulse"></div>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default AccordionShimmer;
